import "./index.scss";
import { Button, Select, Tooltip } from "antd";
import { isNullOrEmptyString } from "../../common/utils";
import { VerificationStatusComponent } from "../verificationStatusComponent";
import { VerificationStatus } from "../verificationStatusComponent/model";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;

export const ReviewDecisionComponent = ({
  selected,
  placeHolder,
  handleChange,
  disabled,
  backgroundColor = "white",
  mandatory = false,
  verificationStatus,
  handleClear,
  allowClear = true,
  handleClearSaved,
  ...restProps
}) => {
  if (disabled) {
    backgroundColor = "#ECECEC";
  }
  if (isNullOrEmptyString(selected)) {
    selected = undefined;
  }
  placeHolder = placeHolder ?? "Select --";

  let style = {
    backgroundColor,
    width: "100%",
    minWidth: "160px",
  };

  if (mandatory) {
    style.borderColor = "red";
  }

  function shouldNotShowClearSavedIcon() {
    return allowClear || disabled;
  }

  return (
    <div className="review-task-decision-container">
      <div
        style={{
          display: "flex",
          columnGap: shouldNotShowClearSavedIcon() ? "0px" : "10px",
          width: "100%",
        }}
        className={mandatory?"review-task-decision-mandatory":""}
      >
        <Select
          value={selected}
          style={style}
          onChange={handleChange}
          placeholder={placeHolder}
          allowClear={allowClear}
          disabled={disabled}
          onClear={handleClear}
          getPopupContainer={restProps.getPopupContainer}
        >
          <Option value="No change needed">No change needed</Option>
          <Option value="Needs adjustment">Needs adjustment</Option>
          <Option value="Needs removal">Needs removal</Option>
        </Select>
        {shouldNotShowClearSavedIcon() ? null : (
          <Button
            style={{ border: "none", padding: 0, background: "none" }}
            onClick={handleClearSaved}
            aria-label={"clear-saved-decision"}
          >
            <CloseOutlined style={{ color: "#CB3E56" }} />
          </Button>
        )}
      </div>
      <div>
        {isNullOrEmptyString(verificationStatus) ||
        verificationStatus === VerificationStatus.notApplicable ? null : (
          <div className="review-task-verification">
            <Tooltip
              title={verificationStatus}
              placement="top"
              getPopupContainer={restProps.getPopupContainer}
              getTooltipContainer={restProps.getPopupContainer}
            >
              <VerificationStatusComponent verificationStatus={verificationStatus} />
              &nbsp;
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};
